// src/pages/EditJob.js
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ref, get, update, remove } from "firebase/database";
import { db } from "../utilities/firebaseConfig";

const EditJob = () => {
  const { jobId } = useParams();
  const navigate = useNavigate();
  const [jobData, setJobData] = useState({
    title: "",
    description: "",
    serviceType: "",
    scheduledDate: "",
  });

  useEffect(() => {
    const jobRef = ref(db, `jobs/${jobId}`);
    get(jobRef).then((snapshot) => {
      if (snapshot.exists()) {
        setJobData(snapshot.val());
      }
    });
  }, [jobId]);

  const handleChange = (e) => {
    setJobData({ ...jobData, [e.target.name]: e.target.value });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      await update(ref(db, `jobs/${jobId}`), jobData);
      alert("Job updated successfully.");
      navigate(`/job/${jobId}`);
    } catch (error) {
      console.error("Error updating job:", error.message);
    }
  };

  const handleCancel = async () => {
    if (window.confirm("Are you sure you want to cancel this job?")) {
      await remove(ref(db, `jobs/${jobId}`));
      alert("Job cancelled.");
      navigate("/dashboard");
    }
  };

  return (
    <div>
      <h2>Edit / Cancel Job</h2>
      <form onSubmit={handleUpdate}>
        <input type="text" name="title" placeholder="Job Title" value={jobData.title} onChange={handleChange} required />
        <textarea name="description" placeholder="Job Description" value={jobData.description} onChange={handleChange} required />
        <select name="serviceType" value={jobData.serviceType} onChange={handleChange} required>
          <option value="">Select Service Type</option>
          <option value="plumbing">Plumbing</option>
          <option value="electrical">Electrical</option>
          <option value="carpentry">Carpentry</option>
        </select>
        <input type="date" name="scheduledDate" value={jobData.scheduledDate} onChange={handleChange} required />
        <button type="submit">Update Job</button>
      </form>
      <button onClick={handleCancel}>Cancel Job</button>
      <button onClick={() => navigate("/dashboard")}>Back to Dashboard</button>
    </div>
  );
};

export default EditJob;
